import { cn } from '@/lib/utils';
import { FunctionComponent, PropsWithChildren } from 'react';

interface SidebarControlProps {
  onClickCallback: () => void;
  name?: string;
  className?: string;
}

const SidebarControl: FunctionComponent<PropsWithChildren<SidebarControlProps>> = ({
  onClickCallback,
  name,
  className,
  children
}) => {
  return (
    <button
      className={cn(
        'w-full hover:bg-primary-50 flex group items-center justify-between gap-2 rounded-md px-3 py-1.5 text-sm font-medium text-left',
        className
      )}
      onClick={onClickCallback}
    >
      {name && <span>{name}</span>}
      {children}
    </button>
  );
};

export default SidebarControl;
